import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const Byline = ({ a, light = false }) => (
  <div className="flex items-center gap-4" data-testid="article-byline">
    <img src={a.author.photo} alt={a.author.name} className="h-11 w-11 rounded-full object-cover object-[62%_30%] ring-1 ring-[#D4AF37]" />
    <div className="text-sm">
      <p className={`font-display font-semibold ${light ? "text-white" : "text-[#0D9488]"}`}>By {a.author.name}</p>
      <p className={light ? "text-[#CFE7E3]" : "text-[#2D6A64]"}>{a.author.role} · {a.readTime} min read</p>
    </div>
  </div>
);

export const ArticleCard = ({ a, i = 0, large = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
    className="h-full"
  >
    <Link
      to={`/beyond/${a.slug}`}
      data-testid={`article-card-${a.slug}`}
      className={`group grid h-full gap-8 border border-[#E2ECEB] bg-white p-5 transition-[border-color,box-shadow] duration-500 hover:border-[#D4AF37] hover:shadow-[0_30px_60px_-30px_rgba(7,78,72,0.35)] lg:p-6 ${large ? "lg:grid-cols-12 lg:items-center lg:gap-12" : ""}`}
    >
      <div className={`clip-corner overflow-hidden ${large ? "lg:col-span-7" : ""}`}>
        <img src={a.image} alt={a.title} className="aspect-[3/2] w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
      </div>
      <div className={`flex flex-col ${large ? "lg:col-span-5 lg:pr-6" : "px-1 pb-2"}`}>
        <span className="font-display flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-[#0D9488]">
          <span className="h-2 w-2 rotate-45 bg-[#D4AF37]" />
          {a.theme} · {a.readTime} min
        </span>
        <h2 className={`font-display mt-5 font-bold tracking-tight text-[#0D9488] ${large ? "text-3xl lg:text-5xl" : "text-2xl lg:text-3xl"}`}>{a.title}</h2>
        <p className="mt-4 text-base leading-relaxed text-[#2D6A64]">{a.excerpt}</p>
        <span className="font-display mt-8 inline-flex w-fit items-center gap-3 border border-[#0D9488]/40 px-5 py-3 text-sm font-semibold text-[#0D9488] transition-colors duration-300 group-hover:border-[#D4AF37]">
          Read the article
          <span className="transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden>→</span>
        </span>
      </div>
    </Link>
  </motion.div>
);
